<script lang="ts"></script>

<script setup lang="ts">
/**
 * 🅲🅾🅼🅿🅾🅽🅴🅽🆃 [Filed]
 * Поле / обертка
 */

// Types
import type { I_Field } from "./field.types";

const props = defineProps<Partial<I_Field>>();
</script>

<template>
    <div class="tiw__field" :class="[{ tiw__field_error: props.isError }]">
        <div v-if="$slots.title" class="tiw__field__title">
            <slot name="title" />
        </div>
        <div v-if="$slots.hintTop" class="tiw__field__hint tiw__field__hint_top">
            <slot name="hintTop" />
        </div>
        <div class="tiw__field__body">
            <slot name="body" />
        </div>
        <div v-if="$slots.hintBottom" class="tiw__field__hint tiw__field__hint_bottom">
            <slot name="hintBottom" />
        </div>
    </div>
</template>

<style lang="scss" src="./field.scss"></style>
